<template>
    <b-container fluid="sm">
        <b-row class="mb-3">
            <b-col md="8" sm="6">
                <b-card no-body class="overflow-hidden">
                    <b-row no-gutters>
                        <b-col md="12">
                            <b-card-body title="Select the colors and quantities for your bulk order.">
                                <b-card-sub-title class="mb-3">
                                    Orders MUST be in multiples of 32 pieces. E.g 32, 64, 128
                                </b-card-sub-title>
                                <b-row class="bulk-item">
                                    <b-col md="4">
                                        <p class="h6">Color: Solid Red</p>
                                    </b-col>
                                    <b-col md="4">
                                        <b-button variant="danger"></b-button>
                                    </b-col>
                                    <b-col md="4">
                                        <b-input-group>
                                            <b-input-group-prepend>
                                                <b-btn :variant="red == 1 ? 'outline-secondary': 'outline-success'" :disabled="red == 1" @click="red--">-</b-btn>
                                            </b-input-group-prepend>
                                                <b-form-input type="number" :min="1" v-model="red"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="outline-success" @click="red++">+</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row class="bulk-item">
                                    <b-col md="4">
                                        <p class="h6">Color: Transparent Black</p>
                                    </b-col>
                                    <b-col md="4">
                                        <b-button variant="secondary"></b-button>
                                    </b-col>
                                    <b-col md="4">
                                        <b-input-group>
                                            <b-input-group-prepend>
                                                <b-btn :variant="black == 1 ? 'outline-secondary': 'outline-success'" :disabled="black == 1" @click="black--">-</b-btn>
                                            </b-input-group-prepend>
                                                <b-form-input type="number" :min="1" v-model="black"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="outline-success" @click="black++">+</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row class="bulk-item">
                                    <b-col md="4">
                                        <p class="h6">Color: Solid Pink</p>
                                    </b-col>
                                    <b-col md="4">
                                        <b-button variant="danger"></b-button>
                                    </b-col>
                                    <b-col md="4">
                                        <b-input-group>
                                            <b-input-group-prepend>
                                                <b-btn :variant="pink == 1 ? 'outline-secondary': 'outline-success'" :disabled="pink == 1" @click="pink--">-</b-btn>
                                            </b-input-group-prepend>
                                                <b-form-input type="number" :min="1" v-model="pink"></b-form-input>
                                            <b-input-group-append>
                                                <b-btn variant="outline-success" @click="pink++">+</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col md="4" sm="6">
                <b-card style="max-width: 20rem;" class="mb-2">
                    <b-list-group flush>
                        <b-list-group-item>
                            <span>Product Price: </span>
                            <span style="margin-left: 30%">
                                ${{((red + black + pink) * 2.50).toFixed(2)}}
                            </span>
                        </b-list-group-item>
                        <b-list-group-item>
                            <span>Number of Pieces: </span>
                            <span style="margin-left: 35%">{{red + black + pink}}</span>
                        </b-list-group-item>
                    </b-list-group>

                    <b-button id="tooltip-target-1" v-b-tooltip.hover v-on:click="onSubmitBulkOrder" :disabled="(((red + black + pink) % 32) > 0)" variant="success" block>
                        <b-icon-cart-check></b-icon-cart-check>
                        Submit Order
                    </b-button>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  data () {
    return {
      orderAmount: 100,
      numOfPieces: 0,
      red: 1,
      pink: 1,
      black: 1,
      canOrder: false,
      colors: {

      }
    }
  },
  methods: {
    onSubmitBulkOrder () {
      window.analytics.track('Submit Bulk Order Intent')
      let wrap = document.createElement('div')
      wrap.setAttribute('class', 'text-muted')
      wrap.innerHTML = '<form id="embeddedForm"> <div class="form-group"> <input type="email" class="form-control" required id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email address"> </div> <div class="form-group"><input type="text" class="form-control" required id="exampleInputFullName" placeholder="Enter your full name"> </div></form>'
      this.$swal({
        title: 'Bulk Order is currently in progress',
        text: 'We will notify you once you are able to complete your bulk order online',
        content: {
          element: wrap
        },
        button: {
          text: 'Get Notified!'
        }
      }).then(data => {
        let inputEmail = document.getElementById('exampleInputEmail1').value
        let inputFullName = document.getElementById('exampleInputFullName').value
        if (inputEmail.length > 4 && inputFullName != '') {
          window.analytics.alias(inputEmail)
          window.analytics.identify(email, {
            type: 'reseller',
            source: 'bulk_purchase_intent',
            fullName: inputFullName,
            bulkQuantityOrdered: {
              red, pink, black
            }
          })
          window.analytics.track('Submitted Bulk Order Intent', {
            email: email
          })
        } else {
          console.log('something empty')
        }
      })
    }
  }

}
</script>
<style scoped>
.bulk-item {
    margin-top: 12px
}
</style>



// WEBPACK FOOTER //
// src/components/BulkDisplay.vue